import { useEffect, useState } from "react";
import useReduxState from "@hooks/useReduxState";
import { useQuery } from "@apollo/react-hooks";
import { GET_SINGLE_COINFLIP_GAME } from "@graphql/Queries";

import cn from "classnames";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Link, useParams } from "react-router-dom";

import logo from "@assets/svg/logo-name.svg";
import back from "@assets/svg/back-arrow.svg";
import copy from "@assets/svg/copy.svg";
// import eye from "@assets/svg/eye.svg";
import vs from "@assets/svg/vs.svg";

import styles from "./index.module.scss";

export default function InGame(): JSX.Element {
  const [{ username }] = useReduxState((state) => state.userData);
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);

  const { gameId } = useParams();
  const { loading, error, data } = useQuery(GET_SINGLE_COINFLIP_GAME, {
    variables: {
      uid: gameId,
    },
  });

  // Copy game ID to clipboard
  useEffect(() => {
    if (copiedToClipboard) {
      setTimeout(() => setCopiedToClipboard(false), 2500);
    }
  }, [copiedToClipboard]);

  // Current User
  // const { games_won, games_lose } = statistics.coinflip;
  // var winRatio = Number(
  //   ((games_won / (games_won + games_lose)) * 100).toFixed(0)
  // );
  // const progressBarWidth = 138 * (winRatio / 100) + "px";

  // Opponent
  // const { games_won: won, games_lose: lose } = opponent.statistics.coinflip;
  // var opponentWinRatio = Number(((won / (won + lose)) * 100).toFixed(0));
  // const opponentProgressBarWidth = 138 * (opponentWinRatio / 100) + "px";

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error! ${error.message}</div>;

  const coinflip = data.getSingleCoinflipGame;

  return (
    <div className={styles.coinflipGameWrapper}>
      {/* In Game Section */}
      <div className={styles.container}>
        {/* Heading */}
        <div className={styles.heading}>
          <div className={styles.heading__side}>
            <Link to="/games/coinflip">
              <button className={styles.back} aria-label="Go back">
                <img src={back} />
              </button>
            </Link>
            ID : {gameId}
            <CopyToClipboard
              text={gameId || ""}
              onCopy={() => setCopiedToClipboard(true)}
            >
              <button className={styles.copy} aria-label="Copy ID to clipboard">
                <img src={copy} />
              </button>
            </CopyToClipboard>
            <span
              className={cn(styles.copied, {
                [styles.visible]: copiedToClipboard,
              })}
            >
              ✓
            </span>
          </div>
          <div className={styles.heading__middle}>
            <img src={logo} className={styles.logo} />
            <div>Coinflip</div>
          </div>
          {/* <div className={styles.heading__side}>
            <img src={eye} className={styles.eye} />
            {gameViewers}
          </div> */}
        </div>

        {/* Game */}
        <div className={styles.game}>
          <div className={cn(styles.game__side, styles.duel)}>
            <div className={styles.circle}>
              <div
                className={styles.profile}
                style={{
                  backgroundImage: `url(${coinflip.heads_user.avatar_url})`,
                }}
              ></div>
            </div>
            <div
              className={cn(styles.profile, styles.desktop)}
              style={{
                backgroundImage: `url(${coinflip.heads_user.avatar_url})`,
              }}
            ></div>
            <div className={styles.user}>
              <div className={styles.username}>{username}</div>
              <div className={styles.owns}>
                <div className={styles.coin}></div>
                <div className={styles.amount}>{coinflip.stake}</div>
              </div>
            </div>
          </div>

          <div className={styles.game__vs}>
            <img src={vs} />
          </div>

          <div className={cn(styles.game__side, styles.ana)}>
            <div className={styles.user}>
              <div className={styles.username}>
                {coinflip.tails_user.username}
              </div>
              <div className={styles.owns}>
                <div className={styles.coin}></div>
                <div className={styles.amount}>{coinflip.stake}</div>
              </div>
            </div>
            <div
              className={cn(styles.profile, styles.desktop)}
              style={{
                backgroundImage: `url(${coinflip.tails_user.avatar_url})`,
              }}
            ></div>
            <div className={styles.circle}>
              <div
                className={styles.profile}
                style={{
                  backgroundImage: `url(${coinflip.tails_user.avatar_url})`,
                }}
              ></div>
            </div>
          </div>
        </div>

        {/* Statistics */}
        <div className={styles.stats}>
          {/* <div className={cn(styles.stats__rate, styles.duel)}>
            <span>
              <div className={styles.circleDuel}></div>
              {winRatio}%{" "}
            </span>
            winrate
            <div className={styles.stats__rate__bar}>
              <div
                className={styles.stats__rate__progress}
                style={{ width: progressBarWidth }}
              ></div>
            </div>
          </div> */}

          <div className={styles.stats__coins}>
            <div className={styles.coin}></div>
            <div className={styles.amount}>{coinflip.reward}</div>
          </div>

          {/* <div className={cn(styles.stats__rate, styles.stats__rate__ana)}>
            <span>{opponentWinRatio}%</span> winrate
            <div className={styles.circleDuel}></div>
            <div className={styles.stats__rate__bar}>
              <div
                className={styles.stats__rate__progress}
                style={{ width: opponentProgressBarWidth }}
              ></div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
